export const CONSUMER_HOMEPAGE_PREFIX = "consumer.homePage";

/** Max content width for the consumer landing page sections only. */
export const HOMEPAGE_FRONT_PAGE_MAX_WIDTH = "1500px";

export const HOMEPAGE_CONTAINER_STYLES = {
  py: 4,
  px: [4, 6],
  maxWidth: "lg",
  ml: "auto",
  mr: "auto"
};

/**
 * Landing page spacing scale. Every section uses the same vertical padding;
 * when two neighbouring sections share a background, the lower one drops its
 * top padding so the gap between them is a single padding.
 */
export const HOMEPAGE_FRONT_PAGE_CONTAINER_STYLES = {
  ...HOMEPAGE_CONTAINER_STYLES,
  py: { xs: 6, lg: 8 },
  px: { xs: 4, sm: 6, lg: 5 },
  maxWidth: HOMEPAGE_FRONT_PAGE_MAX_WIDTH
};

/**
 * Section heading spacing. Replaces the theme's h2 padding + margin (40px) so
 * every landing page section has the same gap between heading and content.
 */
export const HOMEPAGE_SECTION_TITLE_SX = {
  pb: 0,
  mb: { xs: 3, lg: 4 }
};

/** Small gap inside a section, e.g. between content and the button below it. */
export const HOMEPAGE_INNER_GAP = { xs: 2, lg: 3 };
